import {
	Component,
	EventEmitter,
	Input,
	Output
}                             from '@angular/core';
import { BaseComponent }      from '@core/bases/base-component/base.component';
import { DownloadFormatEnum } from '@shared/components/download-button/download-button.model';
import {
	FormattedDescriptionsMapType,
	IResultConfig,
	IResultFormattedDescription,
	ResultActionEventType,
	ResultActionIdentifierEnum,
	ResultViewPlacementEnum
}                             from '@shared/components/result/result.model';

@Component( {
	selector: 'app-result-view[resultConfig]',
	templateUrl: './result-view.component.html',
	styleUrls: [ './result-view.component.scss' ]
} )
export class ResultViewComponent extends BaseComponent {

	private _resultConfig: IResultConfig;

	public additionalFormattedDescriptionsMap: FormattedDescriptionsMapType;
	public readonly resultActionEnum = ResultActionIdentifierEnum;
	public readonly resultViewPlacementEnum = ResultViewPlacementEnum;

	// Bindings
	@Input() set resultConfig( resultConfig: IResultConfig ) {
		if ( !resultConfig ) { return; }

		this.createFormattedDescriptionsMap( resultConfig.i18n?.additionalFormattedDescriptions );
		this._resultConfig = resultConfig;
	}

	get resultConfig() {
		return this._resultConfig;
	}

	@Output() resultActionEvent: EventEmitter<ResultActionEventType> = new EventEmitter<ResultActionEventType>();

	constructor() {
		super();
	}

	private createFormattedDescriptionsMap( additionalFormattedDescriptions?: IResultFormattedDescription[] ): void {
		if ( !additionalFormattedDescriptions?.length ) { return; }

		const localFormattedDescriptionsMap: FormattedDescriptionsMapType = new Map();

		additionalFormattedDescriptions
		.sort( ( descriptionItemA: IResultFormattedDescription, descriptionItemB: IResultFormattedDescription ) =>
			descriptionItemA.order - descriptionItemB.order
		)
		.forEach(
			( descriptionItem: IResultFormattedDescription ) => {
				const { i18n, order, placement, styleClass } = descriptionItem;

				localFormattedDescriptionsMap.set(
					placement,
					localFormattedDescriptionsMap.has( placement )
					? [
							...localFormattedDescriptionsMap.get( placement ),
							{ i18n, order, styleClass }
						]
					: [ { i18n, order, styleClass } ]
				);
			}
		);

		this.additionalFormattedDescriptionsMap = localFormattedDescriptionsMap;
	}

	copyItemToClipboard(): void {
		if ( this.resultConfig.allowCopyToClipboard ) {
			this.clipboardContent = this.resultConfig?.result;
			this.copyToClipboard( null, true );
		}
	}

	onButtonEvent( identifier: ResultActionIdentifierEnum, eventData?: any ): void {
		let resultAction: ResultActionEventType;
		switch ( identifier ) {
			case ResultActionIdentifierEnum.DOWNLOAD:
				const downloadFormat: DownloadFormatEnum = eventData;
				resultAction = { identifier, downloadFormat };
				break;

			default:
				resultAction = { identifier };
		}
		this.resultActionEvent.emit( resultAction );
	}

}
